<mt-toast-drawer></mt-toast-drawer>

<div class="app-route-content">
  <router-outlet></router-outlet>
</div>
